import { Component, OnInit, AfterContentInit, AfterViewInit, OnChanges, SimpleChanges, Input, ViewChild, ContentChild, ContentChildren, OnDestroy, QueryList, TemplateRef, EventEmitter, Output, ViewChildren, NgZone, Renderer2, ChangeDetectorRef } from '@angular/core';

import { AnimationEvent } from '../animations/animations.interface';

import { AccordionToggleDirective } from './accordion.directive';
export class AccordionHeaderComponent {
public templateRef: TemplateRef<any>;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-accordion-header',
  template: '<ng-template #templateRef><ng-content></ng-content></ng-template>'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'templateRef': [{ type: ViewChild, args: ['templateRef', ] },],
};
}

function AccordionHeaderComponent_tsickle_Closure_declarations() {
/** @type {?} */
AccordionHeaderComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AccordionHeaderComponent.ctorParameters;
/** @type {?} */
AccordionHeaderComponent.propDecorators;
/** @type {?} */
AccordionHeaderComponent.prototype.templateRef;
}

export class AccordionContentComponent {
public templateRef: TemplateRef<any>;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-accordion-content',
  template: '<ng-template #templateRef><ng-content></ng-content></ng-template>'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'templateRef': [{ type: ViewChild, args: ['templateRef', ] },],
};
}

function AccordionContentComponent_tsickle_Closure_declarations() {
/** @type {?} */
AccordionContentComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AccordionContentComponent.ctorParameters;
/** @type {?} */
AccordionContentComponent.propDecorators;
/** @type {?} */
AccordionContentComponent.prototype.templateRef;
}

export class AccordionComponent implements OnInit {
public contentTemplateRef: TemplateRef<AccordionContentComponent>;
public headerStyleColor: string;
public isCollapsing: boolean;
public isCollapsed: boolean;
public index: number;
public borderColor: string;
public contentColor: string;
public contentStyleClass = 'box-body';
public header: string;
public headerColor: string;
public headerColorHover: string;
public headerStyleClass = 'box-header with-border';
public accordionHeaderComponent: AccordionHeaderComponent;
public accordionContentComponent: AccordionContentComponent;
public templateRef: TemplateRef<any>;
/**
 * \@method ngOnInit
 * @return {?}
 */
ngOnInit() {
    this.headerStyleColor = this.headerColor;

    if(!this.header && !this.accordionHeaderComponent) {
      throw new Error('Attribute "header" OR Component "mk-accordion-header" is required for component "mk-accordion"');
    }

    if(this.accordionContentComponent) {
      this.contentTemplateRef = this.accordionContentComponent.templateRef;
    } else {
      this.contentTemplateRef = this.templateRef;
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-accordion',
  template: '<ng-template #templateRef><ng-content></ng-content></ng-template>'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'borderColor': [{ type: Input },],
'contentColor': [{ type: Input },],
'contentStyleClass': [{ type: Input },],
'header': [{ type: Input },],
'headerColor': [{ type: Input },],
'headerColorHover': [{ type: Input },],
'headerStyleClass': [{ type: Input },],
'accordionHeaderComponent': [{ type: ContentChild, args: [AccordionHeaderComponent, ] },],
'accordionContentComponent': [{ type: ContentChild, args: [AccordionContentComponent, ] },],
'templateRef': [{ type: ViewChild, args: ['templateRef', ] },],
};
}

function AccordionComponent_tsickle_Closure_declarations() {
/** @type {?} */
AccordionComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AccordionComponent.ctorParameters;
/** @type {?} */
AccordionComponent.propDecorators;
/** @type {?} */
AccordionComponent.prototype.contentTemplateRef;
/** @type {?} */
AccordionComponent.prototype.headerStyleColor;
/** @type {?} */
AccordionComponent.prototype.isCollapsing;
/** @type {?} */
AccordionComponent.prototype.isCollapsed;
/** @type {?} */
AccordionComponent.prototype.index;
/** @type {?} */
AccordionComponent.prototype.borderColor;
/** @type {?} */
AccordionComponent.prototype.contentColor;
/** @type {?} */
AccordionComponent.prototype.contentStyleClass;
/** @type {?} */
AccordionComponent.prototype.header;
/** @type {?} */
AccordionComponent.prototype.headerColor;
/** @type {?} */
AccordionComponent.prototype.headerColorHover;
/** @type {?} */
AccordionComponent.prototype.headerStyleClass;
/** @type {?} */
AccordionComponent.prototype.accordionHeaderComponent;
/** @type {?} */
AccordionComponent.prototype.accordionContentComponent;
/** @type {?} */
AccordionComponent.prototype.templateRef;
}

export class AccordionGroupComponent implements AfterContentInit, AfterViewInit, OnChanges, OnDestroy {
private activeIndex: any = [0];
private accordionsListeners: Array<Function>;
/**
 * @param {?} value
 * @return {?}
 */
set _activeIndex(value) {
    this.activeIndex = value instanceof Array ? value : [value];
  }
public isMultiple: boolean;
public styleClass = 'box-group'
public onCollapseStart = new EventEmitter();
public onCollapseDone = new EventEmitter();
public accordionComponents: QueryList<AccordionComponent>;
private accordionToggleDirectives: QueryList<AccordionToggleDirective>;
/**
 * \@method constructor
 * @param {?} changeDetectorRef
 * @param {?} ngZone
 * @param {?} renderer2
 */
constructor(
private changeDetectorRef: ChangeDetectorRef,
private ngZone: NgZone,
private renderer2: Renderer2
  ) {}
/**
 * \@method ngAfterViewInit
 * @return {?}
 */
ngAfterContentInit() {
    this.setAccordionsIndex();
    this.updateAccordionIsCollapsed();

    this.accordionComponents.changes.subscribe(changes => {
      this.setAccordionsIndex();
    });
  }
/**
 * \@method ngAfterViewInit
 * @return {?}
 */
ngAfterViewInit() {
    this.setAccordionsToggle();

    this.accordionToggleDirectives.changes.subscribe(changes => {
      this.setAccordionsToggle();
    });
  }
/**
 * [ngOnChanges description]
 * \@method ngOnChanges
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: SimpleChanges) {
    if(changes._activeIndex.firstChange === false) {
      this.updateAccordionIsCollapsed();
    }
  }
/**
 * \@method ngOnDestroy
 * @return {?}
 */
ngOnDestroy() {
    this.removeListeners();
  }
/**
 * [headerMouseEnter description]
 * \@method headerMouseEnter
 * @param {?} accordion
 * @return {?}
 */
public headerMouseEnter(accordion: AccordionComponent): void {
    if(accordion.headerColorHover) {
      accordion.headerStyleColor = accordion.headerColorHover;
    }
  }
/**
 * [headerMouseLeave description]
 * \@method headerMouseLeave
 * @param {?} accordion
 * @return {?}
 */
public headerMouseLeave(accordion: AccordionComponent): void {
    accordion.headerStyleColor = accordion.headerColor;
  }
/**
 * [toggleAccordion description]
 * \@method toggleAccordion
 * @param {?} event
 * @param {?} toggleIndex
 * @return {?}
 */
public toggleAccordion(event: Event, toggleIndex: number): void {
    event.preventDefault();

    let /** @type {?} */ indexOf = this.activeIndex['indexOf'](toggleIndex);
    if(indexOf === -1) {
      if(this.isMultiple) {
        this.activeIndex.push(toggleIndex);
      } else {
        this.activeIndex = [toggleIndex];
      }
    } else {
      if(this.isMultiple) {
        this.activeIndex.splice(indexOf, 1);
      } else {
        this.activeIndex = [];
      }
    }
    this.updateAccordionIsCollapsed();
  }
/**
 * [collapseStart description]
 * \@method collapseStart
 * @param {?} event
 * @param {?} accordion
 * @return {?}
 */
public collapseStart(event: AnimationEvent, accordion: AccordionComponent): void {
    accordion.isCollapsing = true;
    this.onCollapseStart.emit({animationEvent: event, index: accordion.index});
  }
/**
 * [collapseDone description]
 * \@method collapseDone
 * @param {?} event
 * @param {?} accordion
 * @return {?}
 */
public collapseDone(event: AnimationEvent, accordion: AccordionComponent): void {
    accordion.isCollapsing = false;
    this.onCollapseDone.emit({animationEvent: event, index: accordion.index});
  }
/**
 * [setAccordionsIndex description]
 * \@method setAccordionsIndex
 * @return {?}
 */
private setAccordionsIndex(): void {
    this.accordionComponents.forEach((accordion: AccordionComponent, index: number) => {
      accordion.index = index;
    });
  }
/**
 * [setAccordionsToggle description]
 * \@method setAccordionsToggle
 * @return {?}
 */
private setAccordionsToggle(): void {
    this.removeListeners();
    this.ngZone.runOutsideAngular(() => {
      this.accordionToggleDirectives.forEach((accordionToggle: AccordionToggleDirective) => {
        this.accordionsListeners.push(this.renderer2.listen(accordionToggle.elementRef.nativeElement, 'click', (event) => {
          this.toggleAccordion(event, accordionToggle.accordionComponent.index);
          this.changeDetectorRef.detectChanges();
        }));
        this.accordionsListeners.push(this.renderer2.listen(accordionToggle.elementRef.nativeElement, 'mouseenter', (event) => {
          this.headerMouseEnter(accordionToggle.accordionComponent);
          this.changeDetectorRef.detectChanges();
        }));
        this.accordionsListeners.push(this.renderer2.listen(accordionToggle.elementRef.nativeElement, 'mouseleave', (event) => {
          this.headerMouseLeave(accordionToggle.accordionComponent);
          this.changeDetectorRef.detectChanges();
        }));
      });
    });
  }
/**
 * [updateAccordionIsCollapsed description]
 * \@method updateAccordionIsCollapsed
 * @return {?}
 */
private updateAccordionIsCollapsed(): void {
    this.accordionComponents.forEach((accordion: AccordionComponent, index: number) => {
      if(this.activeIndex.indexOf(index) === -1) {
        accordion.isCollapsed = true;
      } else {
        accordion.isCollapsed = false;
      }
    });
  }
/**
 * [removeListeners description]
 * \@method removeListeners
 * @return {?}
 */
private removeListeners(): void {
    if(this.accordionsListeners) {
      this.accordionsListeners.forEach((listener: Function) => {
        listener();
      });
    }
    this.accordionsListeners = [];
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-accordion-group',
  template: `
    <div [ngClass]="styleClass">
      <div *ngFor="let accordion of accordionComponents" class="panel box" [mkColor]="accordion.borderColor" mkColorProperty="border-top-color" mkColorPrefix="box">
        <div [ngClass]="accordion.headerStyleClass" [class.no-border]="accordion.isCollapsed && !accordion.isCollapsing">
          <h4 class="box-title">
            <a [mkAccordionToggle]="accordion" href="#" [mkFontColor]="accordion.headerStyleColor" [class.collapsed]="accordion.isCollapsed">
              {{accordion.header}}
              <ng-template *ngIf="!accordion.header" [ngTemplateOutlet]="accordion.accordionTitleComponent?.templateRef"></ng-template>
            </a>
          </h4>
        </div>
        <div class="panel-collapse" [collapseAnimation]="accordion.isCollapsed" (collapseAnimation.start)="collapseStart($event, accordion)" (collapseAnimation.done)="collapseDone($event, accordion)">
          <div [ngClass]="accordion.contentStyleClass" [mkFontColor]="accordion.contentColor">
            <ng-template [ngTemplateOutlet]="accordion.contentTemplateRef"></ng-template>
          </div>
        </div>
      </div>
    </div>
  `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ChangeDetectorRef, },
{type: NgZone, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'_activeIndex': [{ type: Input, args: ['activeIndex', ] },],
'isMultiple': [{ type: Input },],
'styleClass': [{ type: Input },],
'onCollapseStart': [{ type: Output },],
'onCollapseDone': [{ type: Output },],
'accordionComponents': [{ type: ContentChildren, args: [AccordionComponent, ] },],
'accordionToggleDirectives': [{ type: ViewChildren, args: [AccordionToggleDirective, ] },],
};
}

function AccordionGroupComponent_tsickle_Closure_declarations() {
/** @type {?} */
AccordionGroupComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AccordionGroupComponent.ctorParameters;
/** @type {?} */
AccordionGroupComponent.propDecorators;
/** @type {?} */
AccordionGroupComponent.prototype.activeIndex;
/** @type {?} */
AccordionGroupComponent.prototype.accordionsListeners;
/** @type {?} */
AccordionGroupComponent.prototype.isMultiple;
/** @type {?} */
AccordionGroupComponent.prototype.styleClass;
/** @type {?} */
AccordionGroupComponent.prototype.onCollapseStart;
/** @type {?} */
AccordionGroupComponent.prototype.onCollapseDone;
/** @type {?} */
AccordionGroupComponent.prototype.accordionComponents;
/** @type {?} */
AccordionGroupComponent.prototype.accordionToggleDirectives;
/** @type {?} */
AccordionGroupComponent.prototype.changeDetectorRef;
/** @type {?} */
AccordionGroupComponent.prototype.ngZone;
/** @type {?} */
AccordionGroupComponent.prototype.renderer2;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
